<template>
  <div :class="$style.backBtnWrapper">
    <v-btn
      v-bind="build_props"
      :to="go_to"
      :class="[$style.backBtn, 'pl-0']"
      text
      :active-class="$style.active"
      @click="click_handler"
    >
      <v-icon class="mr-1"> mdi-arrow-left </v-icon>
      <span>
        <slot name="btn-text">
          Назад
        </slot>
      </span>
    </v-btn>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BackBtn extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
  })
  go_to!: unknown

  @Prop({
    type: Function,
    default: () => ({}),
  })
  click_handler!: () => void

  get build_props() {
    return this.go_to ? { to: this.go_to } : {};
  }
}
</script>

<style module lang="scss">
.backBtn {
  margin-bottom: 24px;
}

.backBtn.active {
  &:before {
    opacity: 0 !important;
  }
}

@media (max-width:599px) {
  .backBtnWrapper {
    margin-left: 16px;
  }
}

</style>
